<template>
  <div class="static-integrations-section mt-8 pt-8 border-t border-slate-300 dark:border-zinc-700" data-testid="apps-section">
    <h2 class="text-xl font-semibold mb-3">Apps</h2>
    <p class="text-sm text-zinc-600 dark:text-zinc-400 mb-6">Install our Zight apps into the different tools you already use in your day-to-day operations.</p>

    <div class="static-integrations-grid">
      <StaticIntegrationCard
        v-for="integration in sortedStaticIntegrations"
        :key="integration.name"
        :integration="integration"
        @track-click="trackIntegrationClick"
        @request-integration="handleRequestIntegration"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import StaticIntegrationCard from '../cards/StaticIntegrationCard.vue';
import { useIntegrationStore } from '../../store/useIntegrationStore';
import { useTrack, TrackEvents } from '@/composables/useTrack';
import { useToast } from '@/composables/useToast';

const integrationStore = useIntegrationStore();
const { track } = useTrack();
const { success } = useToast();

const { sortedStaticIntegrations } = storeToRefs(integrationStore);

const trackIntegrationClick = (integrationName: string, comingSoon: boolean = false) => {
  track(TrackEvents.INTEGRATIONS_SETUP, {
    app: integrationName,
    coming_soon: comingSoon,
    setup_requested: false,
  });
};

const handleRequestIntegration = (integrationName: string) => {
  track(TrackEvents.INTEGRATIONS_SETUP, {
    app: integrationName,
    coming_soon: false,
    setup_requested: true,
  });
  success(`Thanks for your interest in ${integrationName}! We've recorded your request and will notify you when it becomes available.`, {
    title: 'Integration Request Submitted',
  });
};
</script>

<style scoped>
.static-integrations-grid {
  @apply grid gap-6 mt-4;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
</style>
